import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, Grid, Icon, Typography } from 'web-library';
import { useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useDispatch } from 'react-redux';
import { DownloadProgressModalProps } from './DownloadProgressModal';
import { disableIdleTimeout, enableIdleTimeout } from '../../store/appSlice';

const useStyles = makeStyles()((theme) =>
({
  dialogContainer: {
    display: 'flex',
    margin: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  dialogContent: {
    padding: theme.spacing(1),
  },
  loadingIndicator:{
    justifyItems: 'center'
  }
}));

const DownloadAuditProgressModal: React.FC<DownloadProgressModalProps> = (
  props: DownloadProgressModalProps
) => {
  const {
    modalState = false,
    fileDownloadStatus = 'UPLOADING',
    onDialogClose = () => null,
  } = props;
  const { classes } = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Disable the idle timer countdown when downloading document.
  useEffect(() => {
    if (modalState) {
      dispatch(disableIdleTimeout());
    } else {
      dispatch(enableIdleTimeout());
    }
  }, [dispatch, modalState]);

  return (
    (<Dialog
      id="opadmin-download-dialog"
      className={classes.dialogContainer}
      fullWidth
      open={modalState}
      maxWidth="sm"
    >
      <DialogContent className={classes.dialogContent}>
        <Grid wrap="wrap" container direction="column">
          <Grid xs={12}>
            {(fileDownloadStatus === 'UPLOADING' ||
              fileDownloadStatus === 'IDLE' ||
              fileDownloadStatus === 'GENERATING') && (
                <Typography display="inline" variant="h4">
                  {t('admin->>TransactionLogList.Please wait while we process your request')}
                </Typography>
              )}
            {(fileDownloadStatus === 'TIMEOUT' || fileDownloadStatus === 'FAILED') && (
              <Typography display="inline" variant="h4">
                {t('admin->>TransactionLogList.Failed to download, please try again later.')}
              </Typography>
            )}
          </Grid>
        </Grid>
        {(fileDownloadStatus === 'UPLOADING' ||
          fileDownloadStatus === 'IDLE' ||
          fileDownloadStatus === 'GENERATING') && (
            <Grid wrap="wrap" container direction="column" alignItems="center">
              <Grid xs={12} className={classes.loadingIndicator}>
                <Icon
                  name={IconName.loadingIndicator}
                  size="L"
                  color={theme.color.link.linkActive02}
                />
              </Grid>
              <Typography display="inline">
                {t('admin->>TransactionLogList.Preparing to export...')}
              </Typography>
            </Grid>
          )}
      </DialogContent>
      {(fileDownloadStatus === 'TIMEOUT' || fileDownloadStatus === 'FAILED') && (
        <DialogActions id="oppadmin-dialog-action">
          <Grid container justify="center" wrap="nowrap" direction="row">
            <Button variant="contained" onClick={onDialogClose}>
              {t('admin->>TransactionLogList.OK')}
            </Button>
          </Grid>
        </DialogActions>
      )}
    </Dialog>)
  );
};
export default DownloadAuditProgressModal;
